import React from "react";
import JsxParser from "react-jsx-parser";
import { usePersonalizedContext } from "../personalization";

const renderError = (e) => {
	return <div>Parser Error</div>;
};

const onError = (e) => {
	console.log("JSX Parser Error", e);
};

const Private = ({ children }) => <span data-cs-mask="">{children}</span>;

export const configureHtmlText = (components = {}) =>
	React.memo(({ children: text = "", bindings = {}, ...props }) => {
		const personalizationData = usePersonalizedContext();
		const binds = { user: personalizationData, ...bindings };
		const componentBindings = {
			Private,
			private: Private,
			...components,
		};

		return typeof text === "string" ? (
			<JsxParser
				autoCloseVoidElements={true}
				components={componentBindings}
				jsx={text}
				onError={onError}
				renderError={renderError}
				renderInWrapper={false}
				bindings={binds}
				blacklistedAttrs={false}
				{...props}
			/>
		) : (
			text
		);
	});

export const HtmlText = configureHtmlText({});
export default HtmlText;
